export default function generateFileKey(fileName) {
  return `${crypto.randomUUID()}-${fileName}`.replace(" ", "-");
}
